// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Our own look for leaflet.markercluster - MarkerCluster.Default.css (the green/yellow/orange
 * bubbles) is deliberately not imported.
 */
.yd-cluster-icon {
  background: transparent;
  border: none;
}

.yd-cluster {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 9999px;
  border: 2px solid #ffffff;
  background: #e7b008;
  color: #1b1f2a;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 1px 4px rgba(10, 25, 47, 0.35);
  font-family: inherit;
}

.yd-cluster--sm {
  font-size: 12px;
}

.yd-cluster--md {
  font-size: 13px;
}

.yd-cluster--lg {
  font-size: 14px;
}

/* A single participant dot, drawn as a divIcon so the cluster group can spiderfy and fade it. */
.yd-dot-icon {
  background: transparent;
  border: none;
}

.yd-dot {
  display: block;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border-radius: 9999px;
}
`, "",{"version":3,"sources":["webpack://./src/components/map/markerCluster.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,gGAAgG;AAChG;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,qBAAqB;AACvB","sourcesContent":["/*\n * Our own look for leaflet.markercluster - MarkerCluster.Default.css (the green/yellow/orange\n * bubbles) is deliberately not imported.\n */\n.yd-cluster-icon {\n  background: transparent;\n  border: none;\n}\n\n.yd-cluster {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  border-radius: 9999px;\n  border: 2px solid #ffffff;\n  background: #e7b008;\n  color: #1b1f2a;\n  font-weight: 700;\n  line-height: 1;\n  box-shadow: 0 1px 4px rgba(10, 25, 47, 0.35);\n  font-family: inherit;\n}\n\n.yd-cluster--sm {\n  font-size: 12px;\n}\n\n.yd-cluster--md {\n  font-size: 13px;\n}\n\n.yd-cluster--lg {\n  font-size: 14px;\n}\n\n/* A single participant dot, drawn as a divIcon so the cluster group can spiderfy and fade it. */\n.yd-dot-icon {\n  background: transparent;\n  border: none;\n}\n\n.yd-dot {\n  display: block;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 9999px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
